module.exports = "/_next/static/images/miningGlobe-b4d62eb56e63a92c0e28ed59c58475c7.png.webp";